export default {
    pikadayLang () {
        return {
            previousMonth : 'Mes anterior',
            nextMonth     : 'Próximo mes',
            months        : ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
            weekdays      : ['Dominog','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
            weekdaysShort : ['Dom','Lun','Mar','Mie','Jue','Vie','Sab']
        }
    },
    prototypeSearch (data, props)  {
        if ( ! e.data ) return false;
        this.users = {};
        var found = {};
        var res = this.usersIndex.search(e.data);
        var backup = this.usersBackup;
        res.forEach(function(index){
            found[index] = backup[index];
        });
        this.users = found;
    },
    toArray (data) {
        var arr = Array();
        for ( var idx in data ) {
            arr.push(data[idx]);
        }
        return arr;
    },
    copy (x) {
        return JSON.parse( JSON.stringify(x) );
    },
    toQueryStr (obj) {
        return '?' + Object.keys(obj).map(function(key) {
            return key + '=' + obj[key]
        }).join('&');
    },
    objectIsEmpty(obj){
        return Object.entries(obj).length === 0 && obj.constructor === Object
    }
}
